module.exports = __webpack_public_path__ + "img/sld_scb_9_t1_red.6acfaadf.svg";